/**
 * Organization Creation Flow
 *
 * Shows after user signs up - prompts them to create or join an organization
 */

import React from 'react';
import { CreateOrganization, OrganizationList } from '@clerk/clerk-react';
import { featureFlags } from '../config/clerk.config';
import { PartyPopper } from 'lucide-react';

function CreateOrganizationFlow() {

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '80vh',
      padding: '20px',
      gap: '30px'
    }}>
      <div style={{ textAlign: 'center', maxWidth: '600px' }}>
        <h1 style={{ fontSize: '32px', marginBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>Welcome to DB Agent! <PartyPopper size={32} /></h1>
        <p style={{ fontSize: '16px', color: '#666', marginBottom: '30px' }}>
          {featureFlags.allowOrganizationCreation 
            ? "Create your organization to get started. You'll be able to invite team members later."
            : "Join an organization you've been invited to, or contact an administrator to be added to an organization."}
        </p>
      </div>

      {/* Clerk's built-in Create Organization component - Only show if creation is allowed */}
      {featureFlags.allowOrganizationCreation && (
        <CreateOrganization 
          appearance={{
            elements: {
              rootBox: 'w-full max-w-md',
              card: 'shadow-lg'
            }
          }}
        />
      )}

      {/* Show list of organizations user can join (if invited) */}
      <div style={{ marginTop: '20px' }}>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '15px' }}>
          {featureFlags.allowOrganizationCreation 
            ? "Or join an organization you've been invited to:"
            : "Join an organization you've been invited to:"}
        </p>
        <OrganizationList 
          hidePersonal={true}
          appearance={{
            elements: {
              rootBox: 'w-full max-w-md'
            }
          }}
        />
      </div>
    </div>
  );
}

export default CreateOrganizationFlow;

